import { Base64 } from "js-base64";

/**
 * Sends a request to reset the password for a user who has forgotten it.
 *
 * The password is Base64-encoded before being sent to the backend.
 * Backend endpoint: `/auth/forget/reset-password`
 *
 * @async
 * @function SaveForPass
 * @param {string} email - The email address of the user.
 * @param {string} password - The new password to set.
 * @returns {Promise<{
 *   data: any,
 *   error: boolean
 * }>} A promise resolving to:
 * - `data`: The response data or error message.
 * - `error`: Indicates whether the request failed.
 *
 * @example
 * const { data, error } = await SaveForPass("user@example.com", "newPassword123");
 * if (!error) {
 *   console.log("Password reset successful");
 * } else {
 *   console.error("Error resetting password:", data);
 * }
 */

const SaveForPass = async (email, password) => {
  const encodedPass = Base64.encode(password.trim());
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/auth/forget/reset-password`;

  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password: encodedPass }),
  };

  try {
    const res = await fetch(url, options);
    const data = await res.json();

    if (res.status === 200) {
      return { data: data, error: false };
    }

    // ✅ Fix: return an object with `data` key for consistency
    return {
      data: data?.message || "Unable to Save  Password, Try again later...",
      error: true,
    };
  } catch (err) {
    console.error("Network error in SaveForPass:", err);
    return { data: "Network error", error: true };
  }
};

export default SaveForPass;
